import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="site-footer">
      <p className="site-footer__statement">A place I’m building, one careful note at a time.</p>
      <div className="site-footer__meta">
        <div>
          <strong>Dr. Neerja Gidwani</strong>
          <span>DNB Psychiatry · Second year</span>
        </div>
        <nav aria-label="Footer links">
          <a href="mailto:hi@neerjagidwani.com">hi@neerjagidwani.com</a>
          <a href="#newsletter">Newsletter</a>
          <a href="https://dghs.mohfw.gov.in/national-mental-health-programme.php" target="_blank" rel="noreferrer">Tele-MANAS <ArrowUpRight size={15} aria-hidden="true" /></a>
          <a href="https://112.gov.in/" target="_blank" rel="noreferrer">Emergency 112 <ArrowUpRight size={15} aria-hidden="true" /></a>
          <a href="#studio">Publisher sign in</a>
        </nav>
        <p>© {new Date().getFullYear()} · Educational information, not medical advice.</p>
      </div>
    </footer>
  );
}
